export const messages = {
  en: {
    adminRepairDetail: {
      title: 'Repair Detail',
      back: 'Back',
      repairId: 'Work Order Code',
      repairType: 'Repair Type',
      repairName: 'Repairer',
      tel: 'Contact',
      location: 'Location',
      appointmentTime: 'Appointment Time',
      status: 'Status',
      repairContent: 'Repair Content',
      maintenanceType: 'Maintenance Type',
      paidService: 'Paid Service',
      freeService: 'Free Service',
      needMaterials: 'Need Materials',
      noMaterials: 'No Materials',
      materials: 'Materials',
      feeDetails: 'Fee Details',
      yuan: 'Yuan (Unit Price * Quantity)',
      comprehensiveScore: 'Comprehensive Score',
      doorSpeedScore: 'Door Speed Score',
      serviceScore: 'Service Score',
      averageScore: 'Average Score',
      points: 'Points',
      visitSatisfaction: 'Visit Satisfaction',
      satisfied: 'Satisfied',
      dissatisfied: 'Dissatisfied',
      visitContent: 'Visit Content',
      repairPhotos: 'Work Order Photos',
      beforePhotos: 'Before Repair Photos',
      afterPhotos: 'After Repair Photos',
      relatedItems: 'Related Items',
      itemId: 'Item ID',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      itemQuantity: 'Item Quantity',
      itemPrice: 'Item Price',
      user: 'User',
      time: 'Time',
      workflow: 'Work Order Flow',
      serial: 'No.',
      handler: 'Handler',
      startTime: 'Start Time',
      endTime: 'End Time',
      duration: 'Duration',
      comment: 'Comment',
      reply: 'Reply',
      replyAppraise: 'Reply Appraise',
      content: 'Content',
      replyPlaceholder: 'Required, please fill in the reply content',
      replyRequired: 'Reply content is required',
      replyMaxLength: 'Reply content cannot exceed 512 characters',
      replySuccess: 'Reply submitted successfully',
      replyError: 'Failed to submit reply',
      invalidOperation: 'Invalid operation',
      dataError: 'Data error',
      loadError: 'Failed to load repair details',
      loadResourceError: 'Failed to load resource records',
      loadUserError: 'Failed to load repair staff'
    }
  },
  zh: {
    adminRepairDetail: {
      title: '报修详情',
      back: '返回',
      repairId: '工单编码',
      repairType: '报修类型',
      repairName: '报修人',
      tel: '联系方式',
      location: '位置',
      appointmentTime: '预约时间',
      status: '状态',
      repairContent: '报修内容',
      maintenanceType: '维修类型',
      paidService: '有偿服务',
      freeService: '无偿服务',
      needMaterials: '需要用料',
      noMaterials: '无需用料',
      materials: '用料',
      feeDetails: '费用明细',
      yuan: '元(单价*数量)',
      comprehensiveScore: '综合评价得分',
      doorSpeedScore: '上门速度评分',
      serviceScore: '维修员服务评分',
      averageScore: '平均分',
      points: '分',
      visitSatisfaction: '回访满意度',
      satisfied: '满意',
      dissatisfied: '不满意',
      visitContent: '回访内容',
      repairPhotos: '工单图片',
      beforePhotos: '维修前图片',
      afterPhotos: '维修后图片',
      relatedItems: '相关物品',
      itemId: '物品资源编号',
      itemType: '物品资源类型',
      itemName: '物品资源名称',
      itemSpec: '物品资源规格',
      itemQuantity: '物品使用数量',
      itemPrice: '物品价格',
      user: '使用人',
      time: '时间',
      workflow: '工单流转',
      serial: '序号',
      handler: '处理人',
      startTime: '处理开始时间',
      endTime: '处理结束时间',
      duration: '耗时',
      comment: '意见',
      reply: '回复',
      replyAppraise: '回复评价',
      content: '内容',
      replyPlaceholder: '必填，请填写回复内容',
      replyRequired: '回复内容不能为空',
      replyMaxLength: '回复内容超过500个字',
      replySuccess: '回复成功',
      replyError: '回复失败',
      invalidOperation: '非法操作',
      dataError: '数据异常',
      loadError: '加载报修详情失败',
      loadResourceError: '加载物品记录失败',
loadUserError: '加载维修人员失败'
    }
  },
  'zh-TW': {
    adminRepairDetail: {
      title: '報修詳情',
      back: '返回',
      repairId: '工單編碼',
      repairType: '報修類型',
      repairName: '報修人',
      tel: '聯繫方式',
      location: '位置',
      appointmentTime: '預約時間',
      status: '狀態',
      repairContent: '報修內容',
      maintenanceType: '維修類型',
      paidService: '有償服務',
      freeService: '無償服務',
      needMaterials: '需要用料',
      noMaterials: '無需用料',
      materials: '用料',
      feeDetails: '費用明細',
      yuan: '元(單價*數量)',
      comprehensiveScore: '綜合評價得分',
      doorSpeedScore: '上門速度評分',
      serviceScore: '維修員服務評分',
      averageScore: '平均分',
      points: '分',
      visitSatisfaction: '回訪滿意度',
      satisfied: '滿意',
      dissatisfied: '不滿意',
      visitContent: '回訪內容',
      repairPhotos: '工單圖片',
      beforePhotos: '維修前圖片',
      afterPhotos: '維修後圖片',
      relatedItems: '相關物品',
      itemId: '物品資源編號',
      itemType: '物品資源類型',
      itemName: '物品資源名稱',
      itemSpec: '物品資源規格',
      itemQuantity: '物品使用數量',
      itemPrice: '物品價格',
      user: '使用人',
      time: '時間',
      workflow: '工單流轉',
      serial: '序號',
      handler: '處理人',
      startTime: '處理開始時間',
      endTime: '處理結束時間',
      duration: '耗時',
      comment: '意見',
      reply: '回覆',
      replyAppraise: '回覆評價',
      content: '內容',
      replyPlaceholder: '必填，請填寫回覆內容',
      replyRequired: '回覆內容不能為空',
      replyMaxLength: '回覆內容超過500個字',
      replySuccess: '回覆成功',
      replyError: '回覆失敗',
      invalidOperation: '非法操作',
      dataError: '數據異常',
      loadError: '加載報修詳情失敗',
      loadResourceError: '加載物品記錄失敗',
      loadUserError: '加載維修人員失敗'
    }
  }
}